<header class="agu-plain-header">
    <div class="agu-plain-header__lead">
        <div class="agu-plain-header__title-row">
            <h1 class="agu-plain-header__title">{{ Title }}</h1>
            <ng-content select="[tag]"></ng-content>
        </div>
        @if (Sub) {
            <p class="agu-plain-header__sub">{{ Sub }}</p>
        }
        <ng-content select="[sub]"></ng-content>
    </div>
    <div class="agu-plain-header__aside">
        @if (Date) {
            <span class="agu-plain-header__date">{{ Date }}</span>
        }
        <ng-content select="[actions]"></ng-content>
    </div>
</header>
